import { recentTimeline } from '@data/siteData';
import { Card, CardContent } from '@components/ui/Card';
import { Building2, Star } from 'lucide-react';

export default function RecentPage() {
  return (
    <div className="py-12 bg-slate-950 min-h-screen">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="mb-10">
          <h1 className="text-3xl sm:text-4xl font-bold text-white mb-4">
            Weitere Baumaßnahmen 2016 bis heute
          </h1>
          <p className="text-lg text-slate-400">
            Fortschritte und Veranstaltungen der Sternwarte von 2016 bis heute.
          </p>
        </div>

        {/* Timeline */}
        <div className="space-y-6">
          {recentTimeline.map((item, index) => (
            <Card key={index}>
              <CardContent className="flex gap-4 py-4">
                <div className="flex flex-col items-center">
                  <div className="w-12 h-12 bg-purple-600/10 rounded-full flex items-center justify-center shrink-0">
                    <Building2 className="text-purple-400" size={20} />
                  </div>
                  {index < recentTimeline.length - 1 && (
                    <div className="w-0.5 flex-1 bg-slate-800 mt-2" />
                  )}
                </div>
                <div className="flex-1 pt-2">
                  <h3 className="text-xl font-bold text-purple-400 mb-2">{item.year}</h3>
                  <p className="text-slate-300">{item.event}</p>
                </div>
              </CardContent>
            </Card>
          ))}
        </div>

        {/* 250 Years Celebration */}
        <div className="mt-12 bg-gradient-to-r from-amber-900/20 to-orange-900/20 rounded-xl p-6 border border-amber-800/30">
          <div className="flex items-start gap-4">
            <div className="w-12 h-12 bg-amber-600/10 rounded-lg flex items-center justify-center shrink-0">
              <Star className="text-amber-400" size={24} />
            </div>
            <div>
              <h2 className="text-xl font-bold text-white mb-2">250 Jahre Sternwarte</h2>
              <p className="text-slate-300">
                Im Jahr 2022 feierte die Alte Sternwarte Mannheim ihr 250-jähriges Bestehen mit
                einem großen Festwochenende. Zahlreiche Veranstaltungen, Führungen und eine
                Künstlerausstellung erinnerten an die lange Geschichte des Hauses.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
